Vue.component("portfolios", {

    props: ["portfolios", "users"],

    mounted () {
        let self = this;
        Bus.$on("portfolio-deleted", function (portfolio) {
            self.portfoliosList = self.portfoliosList.filter(function (item) {
                return item.id !== portfolio.id;
            });
        });
    },

    data () {
        return {
            portfoliosList: this.portfolios,
            form: new AppForm({}),
            showNewPortfolioForm: false
        };
    },

    computed: {
        isLimitedPricingPlan(){
            return this.app.state.pricing_plan === 'limited';
        }
    },

    methods: {
        togglePortfolioCreateForm () {
            this.form.portfolio_name = "";
            this.form.errors.forget();
            this.showNewPortfolioForm = !this.showNewPortfolioForm;
        },

        createPortfolio () {
            App.post("/settings/portfolios/create", this.form)
            .then((response) => {
                window.toastr.success(this.form.portfolio_name + " portfolio created!");
                this.togglePortfolioCreateForm();
                this.portfoliosList.push(response);
            });
        },
    }
});
